import Axios from 'axios'

const space2Check = {
  getSpaces2Check() {
    return Axios.get('api/v1/spaces2Check', {
      ignoreGlobalCatch: true,
    })
  },
  getSpace2Check(space2CheckId) {
    return Axios.get(`api/v1/spaces2Check/${space2CheckId}`, {
      ignoreGlobalCatch: true,
    })
  },
  createDevice(device) {
    return Axios.post('api/v1/spaces2Check', device, {
      ignoreGlobalCatch: true,
    })
  },
  editDevice(device) {
    return Axios.put(`api/v1/spaces2Check/${device.id}`, device, {
      ignoreGlobalCatch: true,
    })
  },
  deleteDevice(device) {
    return Axios.delete(`api/v1/spaces2Check/${device}`, device, {
      ignoreGlobalCatch: true,
    })
  }
}

export default space2Check
